import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ModalInfos } from '../models/modal/modal-infos';
import { AuthService } from '../services/auth/auth.service';
import { ModalService } from '../services/modal/modal.service';
import { Observable } from 'rxjs/internal/Observable';
import { isJwtExpired } from '../utils/commons-utilis';
import { STORAGE_KEYS } from '../enums/commission';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const modalService = inject(ModalService);

  // Extract OAuth callback parameters
  const code = route.queryParams['code'];
  const stateParam = route.queryParams['state'];
  const router = inject(Router);

  if (authService.isLogged) {
    return true;
  }

  const idToken = localStorage.getItem(STORAGE_KEYS.ID_TOKEN);
  const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  if(isJwtExpired(idToken, 180) === false && isJwtExpired(token, 180) === false) {
      authService.isLogged = true;
      return true;
  }

  if (code && stateParam) {
    return new Observable<boolean>(observer => {
    authService.getToken(code, stateParam).subscribe({
      next: (_) => {
        authService.isLogged = true;
        router.navigate(['/']);
        observer.next(false);
        observer.complete();
      },
      error: (error) => {
        // Clear session and retry login without calling logout endpoint
        localStorage.clear();
        authService.isLogged = false;
        modalService.showModal(
          new ModalInfos(
            'Attenzione',
            'Si è verificato un errore in fase di login',
            () => {
              authService.initiateLogin();
            },
            'pi pi-exclamation-triangle',
          ),
        );
        observer.next(false);
        observer.complete();
      },
    })
  });
  } else {
    authService.initiateLogin();
    return false;
  }
};
